import { PlusOutlined } from '@ant-design/icons';
import { ServiceOrderExtraForm } from '@components';
import { L } from '@lib';
import { DeleteExtra, ServiceOrder, ServiceOrderExtra } from '@services';
import { Button, FormInstance, Modal } from 'antd';
import React from 'react';

interface IProps {
  hideAction: boolean;
  showAddModal: boolean;
  showDeleteModal: boolean;
  tableForm: FormInstance<any>;
  addForm: FormInstance<any>;
  dataSource: ServiceOrderExtra[];
  serviceOrders: ServiceOrder[];
  disableServiceAdd: boolean;
  handleAdd: () => void;
  handleDeleteClick: (deleteExtra: DeleteExtra) => void;
  handleCreate: (serviceOrderExtra: ServiceOrderExtra) => Promise<void>;
  setShowAddModal: (value: boolean) => void;
  setShowDeleteModal: (value: boolean) => void;
  isEditing: (record: ServiceOrderExtra) => boolean;
  handleCloseAddModal: () => void;
  handleCancel: () => void;
  handleUpdate: (key: React.Key) => Promise<void>;
  handleDelete: () => void;
  handleEdit: (
    record: Partial<ServiceOrderExtra> & {
      key: React.Key;
    }
  ) => void;
}

const ExtraLabourTable: React.FC<IProps> = ({ ...props }) => {
  const { handleCloseAddModal } = props;
  return (
    <>
      {!props.hideAction && (
        <Button
          size="large"
          onClick={(e) => {
            e.currentTarget.blur();
            props.handleAdd();
          }}
          icon={<PlusOutlined />}
          disabled={props.disableServiceAdd}
          style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: '#fff' }}
        >
          {L('Add extra')}
        </Button>
      )}
      <Modal
        onCancel={handleCloseAddModal}
        footer={null}
        open={props.showAddModal}
        title={L('Add extra')}
      >
        <ServiceOrderExtraForm
          form={props.addForm}
          serviceOrders={props.serviceOrders}
          onFinish={props.handleCreate}
          onCancel={handleCloseAddModal}
        />
      </Modal>
      <Modal
        onCancel={() => props.setShowDeleteModal(false)}
        open={props.showDeleteModal}
        onOk={props.handleDelete}
        title={L('Are you sure you want to remove this record?')}
      />
    </>
  );
};

export default ExtraLabourTable;
